module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('demonstration', {
    attrs: {
      "tag": "h2",
      "title": "scrollbar 组件",
      "description": "基于vue2.0的滚动条组件,代码参考了element UI,element UI没有提供单独的scrollbar滚动条组件,这个组件希望对大家有帮助。",
      "show-content": false
    }
  }), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "基本用法",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode
    }
  }, [_c('template', {
    slot: "description"
  }), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('div', {
    staticClass: "bigbox"
  }, [_c('vm-scrollbar', {
    attrs: {
      "tag": "ul",
      "wrapStyle": {
        height: '300px'
      }
    }
  }, _vm._l((6), function(item) {
    return _c('li', {
      staticClass: "smallbox"
    }, [_vm._v(_vm._s(item))])
  }))], 1)])]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n      传入参数 tag=\"ul\" 组件生成ul\n      "), _c('br'), _vm._v("\n      ul为内层内容盒子\n      "), _c('br'), _vm._v("\n      外层盒子一般设置最大高度\n      "), _c('br'), _vm._v("\n      高度只能是具体数值不可以是百分比\n    ")])], 2), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-demo__item"
  }, [_c('h3', {
    attrs: {
      "id": "attributes"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "./#attributes",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v("\n      Attributes\n    ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("wrapClass")]), _vm._v(" "), _c('td', [_vm._v("外层container盒子类名,高度不可是百分比,不可设置宽度")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("viewClass")]), _vm._v(" "), _c('td', [_vm._v("内层内容盒子类名")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("wrapStyle")]), _vm._v(" "), _c('td', [_vm._v("外层container盒子样式,高度不可是百分比,不可设置宽度")]), _vm._v(" "), _c('td', [_vm._v("object")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("viewStyle")]), _vm._v(" "), _c('td', [_vm._v("内层内容盒子样式")]), _vm._v(" "), _c('td', [_vm._v("object")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("tag")]), _vm._v(" "), _c('td', [_vm._v("内层生成的标签")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("div")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("barWidth")]), _vm._v(" "), _c('td', [_vm._v("滚动条宽度")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("6")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("barClass")]), _vm._v(" "), _c('td', [_vm._v("滚动条类名，可以自定义滚动条样式，不可以设置宽高")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("noresize")]), _vm._v(" "), _c('td', [_vm._v("如果 container 尺寸不会发生变化，最好设置它可以优化性能")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("true/false")]), _vm._v(" "), _c('td', [_vm._v("false")])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8e6357ac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e6357ac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/src/App.vue
// module id = 18
// module chunks = 0